export const dedicated = {
  title: 'Server Dedicati',
  subtitle: 'Server dedicati ad alte prestazioni per applicazioni esigenti',
  features: {
    hardware: {
      title: 'Hardware Premium',
      description: 'Processori Intel e AMD di ultima generazione'
    },
    security: {
      title: 'Sicurezza Avanzata',
      description: 'Protezione DDoS fino a 4 Tbps inclusa'
    },
    performance: {
      title: 'Alte Prestazioni',
      description: 'Storage NVMe e rete 10Gbps'
    }
  },
  plans: {
    title: 'Server Disponibili',
    falkenstein: {
      servers: [
        {
          title: 'Server Intel i9',
          price: '€76.99',
          specs: [
            'Intel Core™ i9-9900K',
            '64 GB DDR4',
            '2 x 1TB NVMe SSD',
            'Banda illimitata (fair-use)',
            'Uplink 1Gbps',
            'Supporto 24/7',
            'Protezione DDoS Avanzata (4Tbps+)'
          ]
        },
        {
          title: 'Server AMD Ryzen 5',
          price: '€84.99',
          specs: [
            'AMD Ryzen™ 5 3600',
            '64 GB DDR4',
            '2 x 512GB NVMe SSD',
            'Banda illimitata (fair-use)',
            'Uplink 1Gbps',
            'Supporto 24/7',
            'Protezione DDoS Avanzata (4Tbps+)'
          ]
        },
        {
          title: 'Server Intel i5',
          price: '€84.99',
          specs: [
            'Intel Core™ i5-12500',
            '64 GB DDR4',
            '2 x 512GB NVMe SSD',
            'Banda illimitata (fair-use)',
            'Uplink 1Gbps',
            'Supporto 24/7',
            'Protezione DDoS Avanzata (4Tbps+)'
          ]
        },
        {
          title: 'Server AMD Ryzen 9 Pro',
          price: '€119.99',
          specs: [
            'AMD Ryzen™ 9 7950X3D',
            '128GB DDR4',
            '2 x 2TB NVMe SSD',
            'Banda illimitata (fair-use)',
            'Uplink 1Gbps',
            'Supporto 24/7',
            'Protezione DDoS Avanzata (4Tbps+)'
          ]
        },
        {
          title: 'Server AMD Ryzen 9 Enterprise',
          price: '€169.99',
          specs: [
            'AMD Ryzen™ 9 7950X3D',
            '128GB DDR4',
            '2 x 4TB NVMe SSD',
            'Banda illimitata (fair-use)',
            'Uplink 1Gbps',
            'Supporto 24/7',
            'Protezione DDoS Avanzata (4Tbps+)'
          ]
        }
      ]
    }
  }
};
